"use strict";

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importStar(require("react"));

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_application_1 = require("@ryerson/frontend.application");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var react_2 = require("@emotion/react");

var frontend_button_1 = require("@ryerson/frontend.button");

var polished_1 = require("polished");

var frontend_application_2 = require("@ryerson/frontend.application");

var frontend_layout_2 = require("@ryerson/frontend.layout");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var frontend_common_1 = require("@ryerson/frontend.common");

var Divider = styled_1.default.hr(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tmargin: 15px 0;\n\tborder-top: 1px solid ", ";\n\topacity: 0.1;\n"])), function (props) {
  return props.white;
});

var closeButton = function closeButton(props) {
  return (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\twidth: 50px;\n\theight: 50px;\n\tborder-left: 1px solid ", ";\n"])), (0, polished_1.rgba)(props.color, 0.1));
};

var closeButtonWrapper = function closeButtonWrapper(props) {
  return (0, react_2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\tbackground-color: ", ";\n\tpadding-left: 20px;\n"])), props.color);
};

var ModalContent = styled_1.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\twidth: ", ";\n\tbackground-color: ", ";\n\tpadding-bottom: 50px;\n"])), function (props) {
  return props.isMobile ? "100%" : "500px";
}, function (props) {
  return props.background;
});
var SwitchAccountWrapper = styled_1.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\tmargin: 25px 25px 60px 25px;\n"])));
var AccountsWrapper = styled_1.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\tmargin-top: 24px;\n\tcursor: pointer;\n"])));

var mainContainerStyles = function mainContainerStyles(props) {
  return (0, react_2.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\t@media only screen and (max-width: ", ") {\n\t\tleft: ", ";\n\t\twidth: 100%;\n\t\ttransition: left 0.3s linear;\n\t\tposition: absolute;\n\t\toverflow-y: auto;\n\t\toverflow-x: hidden;\n\t\tz-index: 999;\n\t\tdisplay: ", ";\n\t}\n"])), props.breakpoint, props.isActive ? "0%" : "-100%", props.isActive ? "block" : "none");
};

var SwapAccount = function SwapAccount(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      isMobile = _ref.isMobile,
      handleClose = _ref.handleClose,
      openSwapAccount = _ref.openSwapAccount;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _theme$colors$primary = theme.colors.primary,
      white = _theme$colors$primary.white,
      primaryBrand = _theme$colors$primary.primaryBrand,
      darkGray = _theme$colors$primary.darkGray,
      lighterGray = _theme$colors$primary.lighterGray;

  var _ref3 = (0, frontend_application_1.useApplication)(),
      profile = _ref3.profile,
      axiosInstance = _ref3.axiosInstance,
      setUser = _ref3.setUser,
      user = _ref3.user,
      language = _ref3.localization.language;

  var _ref4 = (0, react_1.useState)(""),
      _ref5 = _slicedToArray(_ref4, 2),
      bodyStyles = _ref5[0],
      setBodyStyles = _ref5[1];

  var _ref6 = (0, react_1.useState)(function () {
    var currVal = (0, frontend_common_1.getSessionItem)(frontend_common_1.SessionItems.swapAccountActive);
    return currVal === "true" ? true : false;
  }),
      _ref7 = _slicedToArray(_ref6, 2),
      isActive = _ref7[0],
      setIsActive = _ref7[1];

  (0, react_1.useEffect)(function () {
    var body = document === null || document === void 0 ? void 0 : document.querySelector("body");

    if (openSwapAccount === true) {
      setIsActive(true);
      setBodyStyles((body === null || body === void 0 ? void 0 : body.getAttribute("style")) || "");
      sessionStorage.setItem(frontend_common_1.SessionItems.swapAccountActive, "true");
    } else {
      setIsActive(false);
      body && body.setAttribute("style", bodyStyles);
      sessionStorage.setItem(frontend_common_1.SessionItems.swapAccountActive, "false");
    }
  }, [openSwapAccount]);

  var handleSwapAccount = function handleSwapAccount(group) {
    var _a;

    if (group && getActiveProfile() && group.locationNumber !== ((_a = getActiveProfile()[0]) === null || _a === void 0 ? void 0 : _a.locationNumber)) {
      var swapAccountRequest = {
        Account: group.locationNumber
      };
      axiosInstance.post("".concat(frontend_common_1.ApiUrl.SWAP_ACCOUNT), swapAccountRequest).then(function (response) {
        (0, frontend_application_2.setLoggedInUser)(response === null || response === void 0 ? void 0 : response.data, setUser);
      }).catch(function (err) {
        console.warn(err);
      });
    }

    handleClose(true, false);
  };

  var getActiveProfile = function getActiveProfile() {
    var activeProfile = profile.groups.filter(function (group) {
      return group.locationNumber === user.account;
    });
    return activeProfile ? activeProfile : profile.groups;
  };

  return (0, jsx_runtime_1.jsx)("div", {
    css: mainContainerStyles({
      isActive: isActive,
      breakpoint: theme.breakpoints.lg
    }),
    children: (0, jsx_runtime_1.jsxs)(ModalContent, {
      className: className,
      isMobile: isMobile,
      background: isMobile ? lighterGray : white,
      children: [isMobile && (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        justifyContent: isMobile ? "space-between" : "flex-end",
        alignItems: "center",
        style: closeButtonWrapper({
          color: darkGray
        }),
        children: (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, {
          children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
            alignItems: "center",
            onClick: function onClick() {
              return handleClose(true, true);
            },
            children: [(0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
              size: "xs",
              label: "",
              circleLabelOrient: "right",
              onClick: function onClick() {
                return handleClose(true, true);
              },
              shape: "circle",
              leftIcon: "chevron-left",
              background: white,
              variant: "outline"
            }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
              style: (0, react_2.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\tmargin-left: 15px;\n\t\t\t\t\t\t\t\t\t"]))),
              children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                size: "lg",
                color: white,
                children: "Back"
              })
            })]
          }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
            justifyContent: "center",
            alignItems: "center",
            style: closeButton({
              color: white
            }),
            onClick: function onClick() {
              return handleClose(true);
            },
            children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
              icon: "close",
              size: "sm",
              onClick: function onClick() {
                return handleClose(true);
              },
              color: white
            })
          })]
        })
      }), (0, jsx_runtime_1.jsxs)(SwitchAccountWrapper, {
        children: [isMobile ? (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          variant: "h3",
          children: frontend_common_1.withTranslation["switchAccounts"][language]
        }) : null, (0, jsx_runtime_1.jsx)(Divider, {
          color: darkGray
        }), profile && (profile === null || profile === void 0 ? void 0 : profile.groups.map(function (group, index) {
          return (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, {
            children: [(0, jsx_runtime_1.jsx)(AccountsWrapper, {
              onClick: function onClick() {
                return handleSwapAccount(group);
              },
              children: (0, jsx_runtime_1.jsx)(frontend_layout_2.Grid, {
                gutter: 0,
                children: (0, jsx_runtime_1.jsxs)(frontend_layout_2.Row, {
                  children: [(0, jsx_runtime_1.jsx)(frontend_layout_2.Column, {
                    xs: 1,
                    children: getActiveProfile()[0].locationName === group.locationName && getActiveProfile()[0].locationNumber === group.locationNumber ? (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                      wrap: "wrap",
                      direction: "column",
                      children: (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
                        size: "xs",
                        type: "secondary",
                        shape: "circle",
                        label: "",
                        leftIcon: "check",
                        onClick: function onClick() {}
                      })
                    }) : (0, jsx_runtime_1.jsx)(react_1.default.Fragment, {})
                  }), (0, jsx_runtime_1.jsx)(frontend_layout_2.Column, {
                    xs: 11,
                    children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
                      direction: "column",
                      style: (0, react_2.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tmargin-left: 15px;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"]))),
                      children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                        size: "lg",
                        color: primaryBrand,
                        css: {
                          marginBottom: "10px",
                          marginTop: 0
                        },
                        children: group.groupName
                      }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                        size: "md",
                        children: group.locationName
                      }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                        size: "md",
                        children: group.locationNumber
                      })]
                    })
                  })]
                })
              })
            }), index !== profile.groups.length - 1 && (0, jsx_runtime_1.jsx)(Divider, {
              color: darkGray
            })]
          }, index);
        }))]
      })]
    })
  });
};

exports.default = SwapAccount;